module.exports = __webpack_public_path__ + "img/star.53ef82c1.svg";